import React from "react";
import PropTypes from "prop-types";
import PlusMinusInput from "./PlusMinusInput";
import { cloneDeep, isFinite } from "lodash-es";
import Products from "../../../../lib/regular/products";
import { Checkbox } from "antd";

const SelectNewSuppliesCard = (props) => {
  const attachProductIfNotExist = (product) => {
    const addedProducts = cloneDeep(props.addedProducts);
    if (!addedProducts[product.id]) {
      addedProducts[product.id] = cloneDeep(product);
      addedProducts[product.id].quantity = 0;
    }
    return addedProducts;
  };

  const addProduct = (product, quantity) => {
    const addedProducts = attachProductIfNotExist(product);
    addedProducts[product.id].quantity += +quantity;
    if (addedProducts[product.id].quantity <= 0) delete addedProducts[product.id];
    props.onProductChange(addedProducts);
  };

  const setProductQuantity = (product, quantity) => {
    if (!isFinite(+quantity)) quantity = 0;
    const addedProducts = attachProductIfNotExist(product);
    addedProducts[product.id].quantity = +quantity;
    if (addedProducts[product.id].quantity <= 0) delete addedProducts[product.id];
    props.onProductChange(addedProducts);
  };

  const buildPlusMinusInput = (product) => {
    const { name, id } = product;
    const { addedProducts } = props;
    const quantity = addedProducts[id] ? addedProducts[id].quantity : 0;
    const price = (Products.getUnitPrice(product) / 100).toFixed(2);
    return (
      <div className="product-controller" key={id}>
        <PlusMinusInput
          onMinusClick={() => addProduct(product, -1)}
          onQuantityChange={(quantity) => setProductQuantity(product, quantity)}
          onPlusClick={() => addProduct(product, 1)}
          value={quantity}
        />

        <div className="product-detail">
          <div className="product-name">{name}</div>
          <div className="product-price">${price}</div>
        </div>
      </div>
    );
  };

  const buildFeeColumn = (fees) => {
    return (
      <div className="product-column">
        <div className="column-title">ADDITIONAL FEES</div>
        {fees.map((fee) => buildFeeCheckBox(fee))}
      </div>
    );
  };

  const buildColumn = (list, title) => {
    return (
      <div className="product-column">
        <div className="column-title">{title}</div>
        {list.map((item) => buildPlusMinusInput(item))}
      </div>
    );
  };

  const onSelectFee = (fee) => {
    const addedProducts = cloneDeep(props.addedProducts);
    if (addedProducts[fee.id]) {
      delete addedProducts[fee.id];
    } else {
      addedProducts[fee.id] = { ...cloneDeep(fee), quantity: 1 };
    }

    props.onProductChange(addedProducts);
  };

  const buildFeeCheckBox = (fee) => {
    const { name, id } = fee;
    const { addedProducts } = props;
    const checked = !!addedProducts[id];
    const price = (Products.getUnitPrice(fee) / 100).toFixed(2);
    return (
      <div className="product-controller" key={id}>
        <Checkbox onChange={() => onSelectFee(fee)} checked={checked}>
          <div className="product-detail">
            <div className="product-name">{name}</div>
            <div className="product-price">${price}</div>
          </div>
        </Checkbox>
      </div>
    );
  };

  const visibleProducts = Products.getAdminVisibleProducts(props.products);
  const supplies = Products.getSupplies(visibleProducts);
  const fees = Products.getFees(visibleProducts);

  return (
    <div className="select-new-supply-card">
      {buildColumn(supplies, "SUPPLIES")}
      {buildFeeColumn(fees)}
    </div>
  );
};

SelectNewSuppliesCard.propTypes = {
  products: PropTypes.array.isRequired,
  addedProducts: PropTypes.object.isRequired,
  onProductChange: PropTypes.func.isRequired,
};

export default SelectNewSuppliesCard;
